import Header from '@/components/Header/Header';
import { createFileRoute } from '@tanstack/react-router';
import { FormattedMessage, useIntl } from 'react-intl';
import { useGetTenant } from '@/api/trafikportalen';
import MarkdownContent from '@/MarkdownContent.tsx';
import { Loading } from '@/components/Loading.tsx';
import { CenteredColumn } from '@/components/CenteredColumn';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute(
  '/$tenantId/_layout/terms-and-conditions/',
)({
  component: GeneralTerms,
});

function GeneralTerms() {
  const { data: tenant, isLoading } = useGetTenant();
  const { formatMessage } = useIntl();

  if (isLoading || !tenant) {
    return <Loading />;
  }

  return (
    <div className="overflow-y-auto">
      <DocumentHead
        titleKey="page.termsAndConditions.title"
        descriptionKey="page.termsAndConditions.description"
      />
      <Header title={<FormattedMessage defaultMessage="Allmänna villkor" />} />
      <CenteredColumn>
        <MarkdownContent
          markdownText={
            tenant.terms_and_conditions ||
            formatMessage({
              defaultMessage: 'Det finns inga allmänna villkor ännu.',
            })
          }
        />
      </CenteredColumn>
    </div>
  );
}
